import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { useMapViewport } from '@pass-frontend/common/offerings/data-bridge';
import { MemberLocation } from '@pass-frontend/data-access/common/edge';
import {
  dashboardListDataMapVar,
  eventListDataMapVar,
} from '@pass-frontend/data-access/state-management/apollo';
import {
  MEMBER_LAST_LOCATION_MUTATION,
  updateOnMemberLastLocationMutation,
} from '@pass-frontend/features/membership/data-access';

// NOTE: temp solution until this API details is finalized
export interface UpdateMemberAddressRequestGQL {
  summary: string;
  latitude: number;
  longitude: number;
}

// TODO: rename to `use-update-address`
export const useUpdateMemberLocation = () => {
  const [updateCurrentAddressMutation] = useMutation<{
    updateMemberLastLocation: MemberLocation | Promise<MemberLocation>;
  }>(MEMBER_LAST_LOCATION_MUTATION, {
    refetchQueries: 'active',
    optimisticResponse: ({ latitude, longitude, summary = '' }) => {
      return {
        updateMemberLastLocation: {
          summary,
          latitude,
          longitude,
          __typename: 'MemberLocation',
        },
      };
    },
    update: updateOnMemberLastLocationMutation,
  });
  const { updateIsSearchArea } = useMapViewport();

  const mutateMemberLocation = useCallback(
    (vars: UpdateMemberAddressRequestGQL) => {
      updateIsSearchArea(true);

      dashboardListDataMapVar({});
      eventListDataMapVar({});

      return updateCurrentAddressMutation({ variables: vars });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateCurrentAddressMutation],
  );

  return {
    mutateMemberLocation,
  };
};
